import ThemeConfig from 'src/theme';
import { ActionPathNavbarInner } from 'src/components/action-path-navbar/ActionPathNavbarInner';

export const ActionPathNavbar = ({
  tourType,
  pathFinderLine,
  setVisible,
  sdk,
  enableNavBar,
  destinationTitle,
  icon,
  autoNavigation,
  enableTeleportBtn,
  distance,
  playButtonType,
  setPlayButtonType,
  style,
  navigationMode,
  setActionPathFinished,
  setTeleportFinished,
  navigationSettings,
  webMode,
  rtl,
  sliderValue,
  setSliderValue,
  translation,
  resetNavigationByCloseButton,
  calculateDistanceIn,
}) => {
  return (
    <ThemeConfig>
      <ActionPathNavbarInner
        tourType={tourType}
        navigationMode={navigationMode}
        style={style}
        pathFinderLine={pathFinderLine}
        setVisible={setVisible}
        sdk={sdk}
        enableNavBar={enableNavBar}
        destinationTitle={destinationTitle}
        icon={icon}
        autoNavigation={autoNavigation}
        enableTeleportBtn={enableTeleportBtn}
        distance={distance}
        playButtonType={playButtonType}
        setPlayButtonType={setPlayButtonType}
        setActionPathFinished={setActionPathFinished}
        setTeleportFinished={setTeleportFinished}
        navigationSettings={navigationSettings}
        webMode={webMode}
        rtl={rtl}
        sliderValue={sliderValue}
        setSliderValue={setSliderValue}
        translation={translation}
        resetNavigationByCloseButton={resetNavigationByCloseButton}
        calculateDistanceIn={calculateDistanceIn}
      />
    </ThemeConfig>
  );
};
